import { useLocation } from 'react-router-dom';

/**
 * הקרן הנוכחית לפי הכתובת, לרכיבים שיושבים ב-Layout ולכן מחוץ ל-FundProvider.
 *
 * למה לא useFundContext: ה-provider נמצא בתוך UserPage, כלומר רק מתחת ל-:fundId.
 * רכיב בכותרת שקורא לו מפיל כל מסך של אזור הניהול ב-"useFundContext must be used
 * within a FundProvider" ומסך לבן. הכותרת לא יכולה להיות תלויה בקונטקסט של נתיב.
 *
 * נתיבי הקרן הם /:fundId/..., ולכן המקטע הראשון הוא המזהה כשהוא מספרי; לאזור
 * הניהול אין קרן בכלל, ושם מוחזר null - וזו התשובה הנכונה.
 */
export function useFundIdFromPath(): string | null {
  const { pathname } = useLocation();
  const firstSegment = pathname.split('/').filter(Boolean)[0];

  return firstSegment && /^\d+$/.test(firstSegment) ? firstSegment : null;
}

export default useFundIdFromPath;
